// extracted by mini-css-extract-plugin
export default {"mask":"mask___rG3K7"};